import { render } from "./HomeItsContactComp.vue?vue&type=template&id=1cd640fc&scoped=true"
import script from "./HomeItsContactComp.vue?vue&type=script&lang=js"
export * from "./HomeItsContactComp.vue?vue&type=script&lang=js"

import "./HomeItsContactComp.vue?vue&type=style&index=0&id=1cd640fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd640fc"]])

export default __exports__